// @ts-expect-error Missing types
import {compute} from 'compute-scroll-into-view';
import {applyLogicalScrollMargins} from './apply-logical-scroll-margins';

/**
 * Scroll only the *nearest* scrollable ancestor to make `el` visible (using “nearest” alignment).
 * Adds support for logical scroll margins (scroll-margin-inline / block) when the upstream
 * library only considers the physical scroll-margin-* properties via a helper utility.
 */
export function scrollIntoViewNearest(el: HTMLElement, options: ScrollIntoViewOptions = {}) {
    const {behavior, block, inline} = options;

    const actions = compute(el, {block, inline, scrollMode: 'if-needed'});
    if (!actions.length) {
        return;
    }

    const first = actions[0];
    const scrollAncestor = first.el;

    if (scrollAncestor === document.documentElement || scrollAncestor === document.body) {
        return;
    }

    let {top, left} = first;

    // Delegate logical/physical margin enforcement to utility
    ({top, left} = applyLogicalScrollMargins(el, scrollAncestor, {top, left}));

    scrollAncestor.scrollTo({top, left, behavior});
}
